import { render } from "./EmojiPanel.vue?vue&type=template&id=cd3b1a38&scoped=true&ts=true&lang=pug"
import script from "./EmojiPanel.vue?vue&type=script&lang=ts"
export * from "./EmojiPanel.vue?vue&type=script&lang=ts"

import "./EmojiPanel.vue?vue&type=style&index=0&id=cd3b1a38&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3b1a38"]])

export default __exports__